import {
  PersonRecordCreateFetch,
  PersonRecordFetch,
  PersonRecordUpdateFetch,
} from './Record.type';
import axios from '../../../services/axios.service';
import { getEndpointBase } from '../../../services/api.service';

let listRequest: any = null;

const RecordService = {
  getList: (params: PersonRecordFetch) => {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase(`people/${params.personId}/records`), {
      cancelToken: listRequest.token,
      params: {
        page: params.page, 
        page_size: params.perPage,
      }
    });
  },
  getInfo({ personId, recordId }: PersonRecordUpdateFetch) {
    return axios.get(getEndpointBase(`people/${personId}/records/${recordId}`));
  },
  create({ personId, ...params }: PersonRecordCreateFetch) {
    return axios.post(getEndpointBase(`people/${personId}/records`), {
      ...params,
      type: 'RECORD',
    });
  },
  update({ personId, recordId, ...params }: PersonRecordUpdateFetch) {
    return axios.patch(
      getEndpointBase(`people/${personId}/records/${recordId}`),
      {
        ...params,
      },
    );
  },
  delete({ personId, recordId }: PersonRecordUpdateFetch) {
    return axios.delete(
      getEndpointBase(`people/${personId}/records/${recordId}`),
    );
  },
};

export default RecordService;
